/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admincredit_Colcreatedat3Inputs */

const zh_admincredit_colcreatedat3 = /** @type {(inputs: Admincredit_Colcreatedat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建时间`)
};

const en_admincredit_colcreatedat3 = /** @type {(inputs: Admincredit_Colcreatedat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created At`)
};

const es_admincredit_colcreatedat3 = /** @type {(inputs: Admincredit_Colcreatedat3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de creación`)
};

/**
* | output |
* | --- |
* | "Created At" |
*
* @param {Admincredit_Colcreatedat3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const admincredit_colcreatedat3 = /** @type {((inputs?: Admincredit_Colcreatedat3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admincredit_Colcreatedat3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_admincredit_colcreatedat3(inputs)
	if (locale === "en") return en_admincredit_colcreatedat3(inputs)
	return es_admincredit_colcreatedat3(inputs)
});
export { admincredit_colcreatedat3 as "adminCredit_colCreatedAt" }